import { useEffect } from 'react';
import { useCurrentMaster, useCurrentUser, usePrevious } from '@lib/hooks';
import * as FullStory from '@fullstory/browser';

function getUserData(user: ReturnType<typeof useCurrentUser>) {
  if (!user) return;
  return {
    id: user.id,
    rootId: user.user,
    name: user.name,
    email: user.email,
    role: user.roles,
    type: user.type,
    ...(user.salesforceData?.boardSegment
      ? {
          segment: user.salesforceData.boardSegment,
        }
      : {}),
    ...(user.salesforceData?.healthStatus
      ? {
          healthStatus: user.salesforceData.healthStatus,
        }
      : {}),
    ...(user.salesforceData?.specialty
      ? {
          specialty: user.salesforceData.specialty,
        }
      : {}),
    ...(user.salesforceData?.providers
      ? {
          providers: user.salesforceData.providers,
        }
      : {}),
    rolloutFlags: user.rollouts,
  };
}

function useFullStoryIdentify() {
  const user = useCurrentUser();
  const rootAccount = useCurrentMaster();
  const prevUserId = usePrevious(user?.id);

  useEffect(() => {
    if (rootAccount && user && user?.id !== prevUserId) {
      FullStory.identify(rootAccount.id, {
        app: 'patient-app',
        user: getUserData(user),
        root: getUserData(rootAccount),
      });
    }
  }, [user, prevUserId, rootAccount]);
}

export default useFullStoryIdentify;
